/*
 * Regels achter het medewerkersoverzicht, los van Overview.vue.
 *
 * Zie de toelichting in logic/verlenging.js waarom deze regels hier staan.
 */

/**
 * Welke sleutel hoort er mee als een medewerker buiten het systeem om is
 * overeengekomen?
 *
 * Een regel uit de NMBRS-lus van getEmployees() is een niet-opgeslagen Employee
 * met alleen employee_id, het NMBRS-nummer. Daarom stuurde de knop een leeg id
 * mee en kwam er DELETE employee/undefined uit.
 *
 * Het NMBRS-nummer mag nooit als `id` mee: de bestaande route doet findOrFail()
 * op onze primaire sleutel, en dan rondt nummer 1378064 de medewerker met ons id
 * 1378064 af. Zie IHR-182.
 *
 * @returns {{id?: number|string, external_id?: number|string, company_id?: number|string}|null}
 *          null betekent: niet versturen, er is geen sleutel.
 */
export function sleutelVoorAfrondenBuitenSysteem(data, companyId){
  if(!data) return null;
  if(data.id) return { id: data.id };
  if(data.employee_id) return { external_id: data.employee_id, company_id: companyId };
  return null;
}

/**
 * De querystring voor "Wijzig NAW-gegevens".
 *
 * Alleen meegeven wat er is. Bij een medewerker die alleen in NMBRS bestaat zijn
 * beide velden leeg, en dan kwam er letterlijk oldId=undefined in de URL te
 * staan; NewEmployee.vue deed daar employeeService.show() mee en de backend
 * antwoordde met "No query results for model [App\Models\Employee] undefined".
 * Zie IHR-182.
 */
export function queryVoorNawWijziging(data){
  const query = {};
  if(!data) return query;
  const oudeId = data.id || data.employee_id;
  const contractId = data.contract ? data.contract.id : data.id;
  if(oudeId) query.oldId = oudeId;
  if(contractId) query.cId = contractId;
  return query;
}

/**
 * Is dit een bruikbare waarde uit een URL?
 *
 * De tekst "undefined" staat nog in links die eerder zijn gemaakt of opgeslagen,
 * en die is niet leeg, dus een gewone waarheidstest laat hem door.
 */
export function isBruikbaarUrlId(waarde){
  return Boolean(waarde) && waarde !== 'undefined' && waarde !== 'null';
}
